export default __webpack_public_path__ + "static/media/solarbr.a8edfd3e.png";